module.exports = __webpack_public_path__ + "static/media/Intersection 14.329d7967.png";